export default __webpack_public_path__ + "static/media/uploadimg2.63faa98e.svg";